import { makeStyles } from '@material-ui/core'

const useDropzoneStyles = makeStyles(theme => ({
   container: {
      minWidth: 600,
      minHeight: 250,
      padding: theme.spacing(2)
   },
   dragZone: {
      border: '2px dashed rgb(143 143 143 / 61%)',
      width: '100%',
      minHeight: 250,
      overflow: 'hidden',
      boderColor: 'rgb(232 232 232)',
      borderRadius: '4px',
      backgroundColor: '#f9fafc',
      cursor: 'pointer',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
   },
   imgContainer: {
      marginBottom: '2rem',
      padding: '2rem',
      backgroundColor: 'white',
      borderRadius: '50%',
      width: '100px',
      height: '100px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
   },
   dragZoneContent: {
      textAlign: 'center',
      position: 'absolute',
      top: '30%',
      margin: '-25px 0 0 -25px'
   },
   description: {
      marginBottom: '2rem',
      fontSize: '10px'
   }
}))

export default useDropzoneStyles
